// extracted by mini-css-extract-plugin
export default {"container":"styles_container__yp+ys","content":"styles_content__KxTmw"};